export const modalReducer = (state, action) => {
    switch (action.type) {
        case 'SHOW_MODAL': {
            return Object.assign(Object.assign({}, state), { showModal: true, onModalSubmit: action.payload.onModalSubmit, title: action.payload.title, body: action.payload.body, submitBtnText: action.payload.submitBtnText, submitBtnClassName: action.payload.submitBtnClassName, cancelBtnText: action.payload.cancelBtnText, cancelBtnClassName: action.payload.cancelBtnClassName, submitBtnPosition: action.payload.submitBtnPosition, addClassnameBody: action.payload.addClassnameBody, addHeaderelement: action.payload.addHeaderelement, addHeaderClassName: action.payload.addHeaderClassName, modalWithForm: action.payload.modalWithForm });
        }
        case 'HIDE_MODAL': {
            return Object.assign({}, state, {
                showModal: false,
            });
        }
        default:
            throw new Error('Unexpected Action');
    }
};
